import { Pipe, PipeTransform } from '@angular/core';
import { shipmentPackageTypes } from '../../../ngrx/shipment-options';

/**
 * PackageDisplayPipe
 * Replaces a numerical package type indicator with a package type name
 *
 * Usage: value | packageDisplay
 * Example
 *  {{ '02' | packageDisplay }}
 *  formats to 'Customer Supplied Package'
 */

 @Pipe({
   name: 'packageDisplay'
 })
 export class PackageDisplayPipe implements PipeTransform {
   transform(value: string): string {
     return shipmentPackageTypes[value];
   }
 }



// WEBPACK FOOTER //
// /Users/itu/Desktop/impreso_updated_sheets/impresocloud/www/client/src/app/shared/pipes/package-display.pipe.ts